import { render, staticRenderFns } from "./AbkOffersList.vue?vue&type=template&id=54f31a1c&scoped=true&"
import script from "./AbkOffersList.vue?vue&type=script&lang=js&"
export * from "./AbkOffersList.vue?vue&type=script&lang=js&"
import style0 from "./AbkOffersList.vue?vue&type=style&index=0&id=54f31a1c&scoped=true&lang=scss&"
import style1 from "./AbkOffersList.vue?vue&type=style&index=1&id=54f31a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f31a1c",
  null
  
)

export default component.exports